// extracted by mini-css-extract-plugin
module.exports = {"large":"FileIcon_large__2Df4E","normal":"FileIcon_normal__A6WNB","small":"FileIcon_small__1QiNM"};